"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterApplications = exports.PORTAL_APP_NAME = void 0;
exports.PORTAL_APP_NAME = "EpiPortal";
const filterApplications = (applications, appName, isInternal) => applications
    .filter(({ name }) => name !== appName)
    .filter(({ isSubscribed, isAvailable, name }) => isSubscribed || (isInternal && isAvailable) || name === exports.PORTAL_APP_NAME);
exports.filterApplications = filterApplications;
